"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUpdateI18nSettingRequestStatus = exports.getFetchI18nSettingRequestStatus = exports.getFetchI18nOptionsRequestStatus = exports.getLocaleDateSample = exports.getLocaleNumberSample = exports.getAvailableLocales = exports.getLocale = exports.getLanguageOptions = exports.getStagedChangesCount = exports.getStagedChanges = exports.getLocaleOptions = exports.getSelectedLanguage = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _reselect = require("reselect");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _actions = require("./actions");

var FETCH_I18N_OPTIONS = _actions.I18nActionTypes.FETCH_I18N_OPTIONS,
    FETCH_I18N_SETTING = _actions.I18nActionTypes.FETCH_I18N_SETTING,
    UPDATE_I18N_SETTING = _actions.I18nActionTypes.UPDATE_I18N_SETTING;

var getLanguage = function getLanguage(state) {
  return state.languageLocale;
};

var getSelectedLanguage = (0, _reselect.createSelector)([getLanguage], function (language) {
  return language.getIn(['staged', 'language']);
});
exports.getSelectedLanguage = getSelectedLanguage;
var getLocaleOptions = (0, _reselect.createSelector)([getLanguage], function (language) {
  return language.get('localeOptions');
});
exports.getLocaleOptions = getLocaleOptions;
var getStagedChanges = (0, _reselect.createSelector)([getLanguage], function (languageState) {
  return languageState.get('staged').reduce(function (acc, val, key) {
    if (languageState.getIn(['data', key]) !== val) {
      return acc.set(key, val);
    }

    return acc;
  }, (0, _immutable.Map)());
});
exports.getStagedChanges = getStagedChanges;
var getStagedChangesCount = (0, _reselect.createSelector)([getStagedChanges], function (stagedChanges) {
  return stagedChanges.size;
});
exports.getStagedChangesCount = getStagedChangesCount;
var getLanguageOptions = (0, _reselect.createSelector)([getLocaleOptions], function (localeOptions) {
  return localeOptions.toList().map(function (option) {
    return {
      language: option.language,
      isBeta: option.beta
    };
  }).toJS();
});
exports.getLanguageOptions = getLanguageOptions;
var getLocale = (0, _reselect.createSelector)([getLanguage], function (language) {
  return language.getIn(['staged', 'locale']);
});
exports.getLocale = getLocale;
var getAvailableLocales = (0, _reselect.createSelector)([getSelectedLanguage, getLocaleOptions], function (selectedLanguage, localeOptions) {
  var languageOption = localeOptions.get(selectedLanguage, null);
  return languageOption ? languageOption.availableLocale : [];
});
exports.getAvailableLocales = getAvailableLocales;
var getLocaleNumberSample = (0, _reselect.createSelector)([getLocale], function (locale) {
  return _I18n.default.formatNumber(1234.56, _I18n.default.lookup('number.format', {
    locale: locale
  }));
});
exports.getLocaleNumberSample = getLocaleNumberSample;
var getLocaleDateSample = (0, _reselect.createSelector)([getLocale], function (locale) {
  var dateLocale = locale;

  switch (locale) {
    case 'en-ie':
      dateLocale = 'en-gb'; // Workaround for lack of "en-ie" support in Moment; see HubSpot/I18n#129

      break;

    case 'en-nz':
      dateLocale = 'en-au'; // And for lack of "en-nz" support in Moment; see HubSpot/I18n#174

      break;

    case 'es-mx':
      dateLocale = 'es'; // And for lack of "es-mx" support in Moment; see HubSpot/I18n#210

      break;

    default:
      break;
  }

  _I18n.default.moment.locale(dateLocale);

  return _I18n.default.moment().format('L');
});
exports.getLocaleDateSample = getLocaleDateSample;
var getFetchI18nOptionsRequestStatus = (0, _getRequestStatus.default)(FETCH_I18N_OPTIONS);
exports.getFetchI18nOptionsRequestStatus = getFetchI18nOptionsRequestStatus;
var getFetchI18nSettingRequestStatus = (0, _getRequestStatus.default)(FETCH_I18N_SETTING);
exports.getFetchI18nSettingRequestStatus = getFetchI18nSettingRequestStatus;
var getUpdateI18nSettingRequestStatus = (0, _getRequestStatus.default)(UPDATE_I18N_SETTING);
exports.getUpdateI18nSettingRequestStatus = getUpdateI18nSettingRequestStatus;